/**
 * @generated SignedSource<<73d3b666d945c2a8cc6a557b56db1dd9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateTeamContactDialogProps_contact$data = {
  readonly emailAddress: string | null | undefined;
  readonly id: string;
  readonly phoneNumber: string | null | undefined;
  readonly teamName: string;
  readonly " $fragmentType": "UpdateTeamContactDialogProps_contact";
};
export type UpdateTeamContactDialogProps_contact$key = {
  readonly " $data"?: UpdateTeamContactDialogProps_contact$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateTeamContactDialogProps_contact">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateTeamContactDialogProps_contact",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    }
  ],
  "type": "TeamContact",
  "abstractKey": null
};

(node as any).hash = "c9ee012a48d6bf6dcb8be89b94d53335";

export default node;
